import api from '../../../lib/api'
import type { AuthTokens, User } from '../../../types'
import { unregisterPush } from '../../../lib/pushNotifications'

export const authService = {
  async login(email: string, password: string): Promise<AuthTokens> {
    const res = await api.post('/auth/login', { username: email, password })
    localStorage.setItem('access_token', res.data.access_token)
    localStorage.setItem('refresh_token', res.data.refresh_token)
    localStorage.setItem('user', JSON.stringify(res.data.user))
    return res.data
  },

  async logout() {
    // Deregister this device's push token for the CURRENT user before the
    // hard reload below tears down the JS context. Without this, a shared
    // device keeps its device_tokens row after logout, so the next user to
    // log in on the same phone doesn't replace it — both users' rows point
    // at the same token, and the previous user keeps getting notifications
    // meant for whoever's using the device now.
    try {
      await unregisterPush()
    } catch {
      // Best-effort — don't block logout on this
    }
    // Revoke tokens server-side first (best effort — don't block on failure)
    try {
      const refreshToken = localStorage.getItem('refresh_token')
      if (refreshToken) {
        await api.post('/auth/logout', { refresh_token: refreshToken })
      }
    } catch {
      // Token revocation failure is non-blocking — clear local state regardless
    }
    localStorage.removeItem('access_token')
    localStorage.removeItem('refresh_token')
    localStorage.removeItem('user')
    window.location.href = '/login'
  },

  getCurrentUser() {
    const user = localStorage.getItem('user')
    return user && user !== 'undefined' ? JSON.parse(user) : null
  },

  isAuthenticated() {
    return !!localStorage.getItem('access_token')
  },

  async fetchMe(): Promise<User> {
    const res = await api.get('/auth/me')
    // Refresh localStorage so subsequent getCurrentUser() calls are up to date
    localStorage.setItem('user', JSON.stringify(res.data))
    return res.data as User
  },
}
